import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { Subscription } from 'rxjs';
import { ChartOptions } from 'libs/portal/src/models/ChartOptions';
import { Filter } from 'libs/portal/src/models/Filter';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { Endpoints } from '@huge-monorepo/portal/config';

@Component({
  selector: 'app-device-availability-graph',
  templateUrl: './device-availability-graph.component.html',
  styleUrls: ['./device-availability-graph.component.scss'],
})
export class DeviceAvailabilityGraphComponent implements OnInit, OnDestroy {
  @ViewChild('chart', { static: false }) chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  @Input() IDs: number[];

  graphFilterData: Object = {
    StartDate: this.tools.FormatStartDate(new Date(new Date().getDate() - 1).toISOString()),
    EndDate: this.tools.FormatEndDate(new Date().toISOString()),
    TimePeriod: '2',
  };
  TimeFilters: Filter[];
  selectedInterval: Filter;
  graphLoaded = false;
  loading = true;

  sidenavObservable: Subscription;

  constructor(
    private genericService: GenericService,
    private tools: ToolsService,
    // private dateParsePipe: FormatDateTimePipe,
    private endpoints: Endpoints,
    private navigationService: NavigationService,
  ) {}

  ngOnInit() {
    this.chartOptions = {
      series: [],
      chart: {
        type: 'line',
        height: 350,
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
        toolbar: {
          show: true,
        },
      },
      fill: {
        colors: ['#77B6EA'],
        type: 'solid',
        opacity: 0.5,
      },
      colors: ['#77B6EA'],
      stroke: {
        curve: 'stepline',
      },
      dataLabels: {
        enabled: true,
      },
      title: {
        text: 'Router Availability',
        align: 'center',
      },
      markers: {
        size: 1,
        hover: {
          sizeOffset: 4,
        },
      },
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
        title: {
          text: 'Time',
        },
      },
      yaxis: {
        title: {
          text: 'Available (%)',
        },
        min: 0,
        max: 105,
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        floating: true,
        offsetY: -25,
        offsetX: -5,
      },
    };

    this.tools.GetTimeFilters().subscribe((filters) => {
      // console.log(filters);
      this.TimeFilters = filters;
      this.selectedInterval = this.TimeFilters[3];
      setTimeout(() => {
        this.getAvailabilityGraphData();
      }, 500);
    });

    this.sidenavObservable = this.navigationService.GetSideNav(() => {
      if (this.graphLoaded != false) {
        const temp = this.graphLoaded;
        this.graphLoaded = false;
        setTimeout(() => {
          this.graphLoaded = temp;
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sidenavObservable != null) {
      this.sidenavObservable.unsubscribe();
    }
  }

  buildGraphQueryObject() {
    const timePeriod = parseInt(this.graphFilterData['TimePeriod']);
    return {
      DeviceIDs: this.IDs == null ? [] : this.IDs,
      AllDevices: this.IDs == null ? true : false,
      StartDate: this.graphFilterData['StartDate'],
      EndDate: this.graphFilterData['EndDate'],
      Interval: this.selectedInterval.name,
      TimePeriod: timePeriod > 0 ? timePeriod : null,
    };
  }

  updateSelectedTimeFilter(eve) {
    // console.log("TimeFilter changed: ", eve);
    this.selectedInterval = eve;
    this.refreshGraph();
  }

  updateStart(newDate: string) {
    console.log(newDate);
    this.graphFilterData['StartDate'] = newDate;
  }

  updateEnd(newDate: string) {
    console.log(newDate);
    const d = new Date(newDate);
    const date = new Date(newDate.substr(0, 10));
    date.setHours(d.getUTCHours());
    date.setMinutes(d.getUTCMinutes());
    date.setSeconds(d.getUTCSeconds());
    const today = new Date();
    if (today.getUTCFullYear() == date.getUTCFullYear() && today.getUTCMonth() == date.getUTCMonth() && today.getUTCDate() == date.getUTCDate()) {
      date.setHours(today.getHours() + 2);
      date.setMinutes(today.getUTCMinutes() - 5);
      date.setSeconds(0);
      date.setMilliseconds(0);
      newDate = date.toISOString();
      console.log('Changed new date format to: ' + newDate);
    }

    this.graphFilterData['EndDate'] = newDate;
  }

  getAvailabilityGraphData() {
    // this.loading = true;
    // this.graphLoaded = false;
    const obj = this.buildGraphQueryObject();
    console.log(obj);
    this.genericService.POST(this.endpoints.GET_AVAILABILITY_DATA, obj).subscribe(
      (results) => {
        console.log(results);
        if (results['body'] != null) {
          const labels: any = [];
          // let data = [];
          let count = 0;
          results['body'].forEach((element) => {
            const serie: any = {
              name: element['Device'] != null ? element['Device']['name'] : '-',
              data: [],
            };
            // console.log(element);
            if (element != null && element['Activities'] != null) {
              (element['Activities'] as []).forEach((activity) => {
                if (count == 0) {
                  // let d = this.dateParsePipe.transform(activity["Timestamp"]);
                  const d = this.tools.ParseAPIDateWithTimezone(activity['Timestamp']);
                  labels.push(this.tools.FormatDateTime(d));
                }
                const availability = parseInt(activity['Availability']);
                serie['data'].push(availability);
              });
            }
            this.chartOptions.series?.push(serie);
            count++;
          });
          this.chartOptions.xaxis.categories = labels;
        }
        this.loading = false;
        this.graphLoaded = true;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  timeFrameSelected() {
    if (parseInt(this.graphFilterData['TimePeriod']) != 0) {
      this.refreshGraph();
    }
  }

  refreshGraph() {
    // console.log("refresh graph");
    this.loading = true;
    this.graphLoaded = false;
    this.chartOptions.series = [];
    // this.selectedInterval = this.TimeFilters[3];
    setTimeout(() => {
      this.getAvailabilityGraphData();
    }, 500);
  }
}
